import type { RoutingState } from '@/views/screens/RoutingGuide/types';
import type { FormItemProps, SelectProps } from 'antd';
import type { DefaultOptionType } from 'antd/es/select';
import i18n from 'i18next';
import { type FC, useEffect, useMemo } from 'react';
import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetStateList } from '../../hooks/use-get-state-list';

interface StateSelectProps extends Pick<FormItemProps, 'rules' | 'name'>, Pick<SelectProps, 'mode' | 'placeholder'> {
  label?: string;
  editMode?: boolean;
  margin?: string;
  onChange?: (value?: string) => void;
  className?: string;
  tabIndex?: number;
  disableValidation?: boolean;
  countryCode?: string | string[];
  callbackAllOptions?: (options: DefaultOptionType[]) => void;
  // TODO: refactor selectedState for StateSelect: remove label and value
  selectedState?: (RoutingState & { label: string; value: string })[];
}

export const StateSelect: FC<StateSelectProps> = ({
  placeholder = i18n.t('translation:default.fields.stateProvince.placeholder'),
  label = i18n.t('translation:default.fields.stateProvince.label'),
  countryCode,
  rules = [],
  name,
  margin,
  editMode = true,
  onChange,
  mode,
  className = '',
  disableValidation = false,
  callbackAllOptions,
  selectedState = [],
  tabIndex,
}) => {
  const country = (
    Array.isArray(countryCode) && typeof countryCode[0] === 'string'
      ? countryCode[0]
      : typeof countryCode === 'string'
        ? countryCode
        : null
  )?.trim();

  const { data: stateListOptions = [], isLoading } = useGetStateList({ CountryCode: country, isDisabled: !editMode });

  const options = useMemo(() => {
    if (selectedState?.length) {
      const findState = selectedState.filter((i) => i.countryCode === country).map((i) => i.value.trim());
      return stateListOptions.filter((i) => findState.includes(i.value));
    }
    return stateListOptions;
  }, [stateListOptions, country]);

  useEffect(() => {
    callbackAllOptions?.(options);
  }, [callbackAllOptions, options]);

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      // @ts-ignore
      onChange={onChange}
      className={className}
      mode={mode}
      disableValidation={disableValidation}
      tabIndex={tabIndex}
    />
  );
};
